<template>
  <ListeReferentiel
    ref="liste"
    titre="Types d'examen"
    icone="bi-clipboard2-pulse"
    ressource="type_examens"
    tri-defaut="texa.nom"
    :options-tri="{ Nom: 'texa.nom', Statut: 'texa.isEnabled' }"
    placeholder="Nom du type d'examen…"
    unite="type(s)"
    vide="Aucun type d'examen enregistré."
    :colonnes="4"
    :peut-creer="$store.getters.hasPermission('CONFIG_CREER_TYPE_EXAMEN')"
    libelle-creer="Nouveau type"
    @creer="creation"
  >
    <template #entete>
      <th>Nom</th>
      <th>Statut</th>
      <th>Actions</th>
    </template>
    <template #ligne="{ ligne: type }">
      <td>{{ type.nom }}</td>
      <td>
        <span :class="['badge', type.isEnabled ? 'bg-success' : 'bg-secondary']">{{ type.isEnabled ? 'Activé' : 'Désactivé' }}</span>
      </td>
      <td>
        <div v-if="$store.getters.hasAnyPermission(['CONFIG_MODIFIER_TYPE_EXAMEN', 'CONFIG_SUPPRESSION_TYPE_EXAMEN'])" class="dropdown">
          <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" v-dropdown-fixed>Actions</button>
          <ul class="dropdown-menu">
            <li v-if="$store.getters.hasPermission('CONFIG_MODIFIER_TYPE_EXAMEN')"><a class="dropdown-item" href="#" @click.prevent="modifier(type.id)">Modifier</a></li>
            <li v-if="$store.getters.hasPermission('CONFIG_SUPPRESSION_TYPE_EXAMEN')"><a class="dropdown-item text-danger" href="#" @click.prevent="supprimer(type)">Supprimer</a></li>
          </ul>
        </div>
      </td>
    </template>
  </ListeReferentiel>
</template>

<script>
import ListeReferentiel from '@/components/commun/ListeReferentiel.vue';

export default {
  name: 'ListeTypeExamen',
  components: { ListeReferentiel },
  methods: {
    creation() {
      this.$router.push({ name: 'create_type_examen' });
    },
    modifier(id) {
      this.$router.push({ name: 'edit_type_examen', params: { id } });
    },
    supprimer(type) {
      this.$refs.liste.supprimer({
        id: type.id,
        titre: "Supprimer le type d'examen",
        message: `Supprimer le type d'examen « ${type.nom} » ?`,
        succes: "Type d'examen supprimé.",
      });
    },
  },
};
</script>
